import { useFragment } from '@apollo/client/react';

import { getMemberIdWithFallback } from '@trello/authentication';

import { CrossFlowMemberFragmentDoc } from '../../CrossFlowMemberFragment.generated';
import type { RuntimeEligibilityCheckResult } from './RuntimeEligibilityCheck';

export const useIsCrossFlowMemberConfirmed =
  (): RuntimeEligibilityCheckResult => {
    const memberId = getMemberIdWithFallback();

    const { data, complete } = useFragment({
      fragment: CrossFlowMemberFragmentDoc,
      fragmentName: 'CrossFlowMember',
      from: {
        id: memberId,
        __typename: 'Member',
      },
      optimistic: false,
    });

    // The codegen fragment hook returned `undefined` until the read was
    // complete; this gate preserves that and may be removable later.
    const member = complete ? data : undefined;

    return {
      isEligible: member?.confirmed ?? false,
    };
  };
